import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from "@angular/common";
//import { AllModules, ColDef, GridOptions } from '@ag-grid-enterprise/all-modules';
import { ColDef, GridOptions, GridApi } from "ag-grid-community";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { CheckboxRendererComponent } from "../../../../common/components/ag-grid/checkbox-renderer.component";
import { AgGridBooleanFilterComponent, IBooleanFilterParams } from "../../../../common/components/ag-grid/filters/boolean-filter.component";
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { SubHeader } from "../../../../core/models/sub-header.model";
import { ReportArgs } from "../../../../common/models/reports.model";
import { SubHeaderService } from "../../../../core/services/sub-header.service";
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { DateService } from "../../../../common/services/date.service";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../../../core/models/dialog.model";
import { OnBaseFileUploadLog, OnBaseUploadedFileLogSearchSpec } from '../../../../common/models/onBaseIntegrationAndMapping.model';
import { DocumentManagementService } from '../../../../common/services/document-management.service';




@Component({
    selector: 'onbase-file-upload-report',
    templateUrl: './onbase-file-upload-report.component.html',
    styleUrls: ['./onbase-file-upload-report.component.scss'],
    standalone: false
})
export class OnBaseFileUploadReportComponent implements OnInit, OnDestroy {

    get excelStyles(): any[] {
        if (this.formatService) return this.formatService.excelStyles;
        return [];
    }

    data: OnBaseFileUploadLog[] = [];
    errorDialog: Dialog = new Dialog("An error has occurred.", [new DialogButton("OK", false, () => { return; })]);
    fromDate: Date | null;
    toDate: Date | null;
    _booleanfilterParams = { isInServerSideFilterMode: false, } as IBooleanFilterParams;

    gridOptions: GridOptions;
	gridApi?: GridApi;
    runText: string = "Run Report";

    subHeader: SubHeader = new SubHeader({ title: "Uploaded Documents Listing", buttons: [] });

    subscription: Subscription = new Subscription();

    constructor(private readonly dataService: DocumentManagementService,
        private readonly formatService: GridFormatterService,
        private readonly subheaderService: SubHeaderService,
        private readonly dialogService: DynamicDialogService,
        private readonly dateService: DateService, private readonly datePipe: DatePipe) {
    }

    ngOnInit() {
        this.subheaderService.updateSubHeader(this.subHeader);
        this.fromDate = new Date();
        this.fromDate.setHours(0,0,0,0);
        this.toDate = new Date();
        this.gridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(this.createColumnDefinitions(), false, true, true, true);
		this.gridOptions.suppressColumnVirtualisation = true;
		this.gridOptions.onGridReady = (params) => { 
            this.gridApi = params.api; 
            this.onGridReady(params);
        };
        this.generateReport({ fromDate: this.fromDate, toDate: this.toDate} as ReportArgs);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    createColumnDefinitions(): ColDef[] {
        return [
            {
                headerName: "Program Area",
                headerTooltip: "Program Area",
                field: "programArea",
                tooltipField: "programArea",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 140,
                maxWidth: 165
            } as ColDef,
            {
                headerName: "Document Group",
                headerTooltip: "Document Group",
                field: "documentGroupName",
                tooltipField: "documentGroupName",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 140,
                maxWidth: 200
            } as ColDef,
            {
                headerName: "Document Type",
                headerTooltip: "Document Type",
                field: "documentTypeName",
                tooltipField: "documentTypeName",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 140,
                maxWidth: 200
            } as ColDef,
            {
                headerName: "Uploaded Document File Name",
                headerTooltip: "Uploaded Document File Name",
                field: "uploadedDocumentName",
                tooltipField: "uploadedDocumentName",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 140,
                maxWidth: 200
            } as ColDef,
            {
                headerName: "API #",
                headerTooltip: "API #",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                valueGetter: this.formatApi(),
                tooltipValueGetter: this.formatApi(),
                resizable: true,
                minWidth: 140,
                maxWidth: 165
            } as ColDef,
            {
                headerName: "Company #",
                headerTooltip: "Company #",
                field: "organizationId",
                tooltipField: "organizationId",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                maxWidth: 140,
                minWidth: 140
            } as ColDef,
            {
                headerName: "Company Name",
                headerTooltip: "Company Name",
                field: "organizationName",
                tooltipField: "organizationName",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 140,
                maxWidth: 165
            } as ColDef,
            {
                headerName: "Contact Name",
                headerTooltip: "Contact Name",
                field: "contactDisplayName",
                tooltipField: "contactDisplayName",
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                minWidth: 125,
                maxWidth: 140
            } as ColDef,
            {
                headerName: "Date / Time Stamp",
                headerTooltip: "Date / Time Stamp",
                field: "uploadTimeStamp",
                valueFormatter: this.formatService.formatDate("uploadTimeStamp", "MM/dd/yyyy hh:mm a"),
                valueGetter: this.formatService.formatDate("uploadTimeStamp", "MM/dd/yyyy hh:mm a"),
                tooltipValueGetter: this.formatService.formatDate("uploadTimeStamp"),
                comparator: dateComparator,
                filter: "agDateColumnFilter",
                filterParams: this.formatService.defaultDateFilterParams,
                sort: "desc",
                sortingOrder: ["asc", null, "desc"],
                minWidth: 225,
                maxWidth: 250
            } as ColDef,
            {
                headerName: "Successfully Sent To Onbase",
                headerTooltip: "Successfully Sent To Onbase",
                field: "successfullySentToOnbase",
                tooltipField: "successfullySentToOnbase",
                cellRenderer: CheckboxRendererComponent,
                cellRendererParams: {
                    action: () => { return false; },
                    field: "successfullySentToOnbase",
                    description: "Successfully Sent To OnBase",
                    isVisible: () => { return true; },
                    isEnabled: () => { return false; },
                    renderAsYesNo: true
                },
                tooltipValueGetter: this.formatService.formatBooleanToYesNo("successfullySentToOnbase"),
                filter: AgGridBooleanFilterComponent,
                filterParams: this._booleanfilterParams,
                minWidth: 125,
                maxWidth: 250
            } as ColDef,
        ] as ColDef[];
    }

    downloadReport(args: ReportArgs): void {
        this.fromDate = args.fromDate;
        this.toDate = args.toDate;
        let fileName = `UploadedDocumentsListing_${this.datePipe.transform(this.fromDate, "yyyy-MM-dd").toString()}_${this.datePipe.transform(this.toDate, "yyyy-MM-dd").toString()}`;
        let sheetName = "UploadedDocuments";
        this.formatService.exportDataToExcel(fileName, sheetName, this.gridApi);
    }

    formatApi(): any {
        return (obj: any) => {
            let value = "";
            if (obj && obj.data) {
                value = obj.data.apiNumber;
                if (obj.data.onBaseFileUploadLogKeywords != null) {
                    const apis = obj.data.onBaseFileUploadLogKeywords.filter(f => f.keywordName != null && f.keywordName.toLocaleLowerCase().includes("api id number"));
                    if (apis.length > 0) {
                        value = apis.map((a: any) => a.keywordValue).join(',');
                    }
                }
            }

            return value;
        }
    }

    generateReport(args: ReportArgs) : void {
        this.fromDate = args.fromDate;
        this.toDate = args.toDate;
        const criteria = {} as OnBaseUploadedFileLogSearchSpec;
        criteria.fromDate = this.fromDate;
        criteria.toDate = this.toDate;

        if (this.gridApi) this.gridApi.setGridOption("loading", true); 
        let reports$ = this.dataService.GetUploadedFileLogs(criteria).pipe(
            tap((results) => {
                this.data = results;
            })
        ).subscribe({
            next: (success) => {
                if (this.gridApi != null) {
                    this.gridApi.setGridOption("rowData", this.data);
                    this.gridApi.setGridOption("loading", false);
                    this.gridApi.autoSizeAllColumns();
                }
            },
            error: (error) => {
                console.error(error);
                if (this.gridApi != null) {
                    this.gridApi.setGridOption("loading", false);
                }
                this.showError();
            }
        });
        this.subscription.add(reports$);
        
    }

    onGridReady(event: any) {
        this.formatService.gridReadySizeToFit(event);
    }

    showError(): void {
        this.errorDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.errorDialog);
    }
}
